export default {
  name: 'hengyang',
  adcode: '430400',
  mapName: '衡阳市',
  geoJsonPath: 'hunanmap/430400.json',
  backgroundImage: {
    png: '衡阳市_430400.png',
    webp: '衡阳市_430400.webp'
  },
  echartsMapStyle: {
    width: '862px',
    height: '668px',
    marginTop: 'auto',
    marginBottom: '73px',
  },
  imageSize: {
    width: 3976,
    height: 3084
  },
  // 地图特殊配置：背景图片适配参数
  specialConfig: {
    // 独立调整参数
    layoutSizeAdjustment: {
      enabled: true,
      multiplier: 1.29, // 布局尺寸调整倍数（微调）
      minSize: 400,     // 最小布局尺寸
      maxSize: 1200     // 最大布局尺寸
    },
    aspectScaleAdjustment: {
      enabled: true,
      multiplier: 1, // 宽高比调整倍数（微调）
      minScale: 0.5,    // 最小缩放比例
      maxScale: 2.0     // 最大缩放比例
    },
    // 位置偏移补偿
    positionOffset: {
      x: 0.001,  // X轴偏移百分比
      y: 0.001  // Y轴偏移百分比
    }
  },
  // 区县列表
  districts: ['衡阳市区', '衡阳县', '衡南县', '衡山县', '衡东县', '祁东县', '耒阳市', '常宁市'],
  // 区县坐标映射（用于tooltip定位与涟漪效果）
  cityCoords: {
    // 市区参考坐标（用于兜底展示）
    '衡阳市区': [112.576324, 26.931063],
    '衡阳市': [112.576324, 26.931063],
    // 县与县级市坐标
    '衡阳县': [112.339643, 27.095388],
    '衡南县': [112.607459, 26.689973],
    '衡山县': [112.80171, 27.312808],
    '衡东县': [112.930412, 27.083531],
    '祁东县': [111.981192, 26.777109],
    '耒阳市': [112.827215, 26.408162],
    '常宁市': [112.366821, 26.366773]
  },
  // 区县名称标准化
  normalizeName: (name) => {
    if (!name) return ''
    const s = String(name).trim()
    // 城区归并到“衡阳市区”
    if (s === '衡阳市') return '衡阳市区'
    return s
  },
  // 区县与adcode映射
  cityAdcodeMap: {
    '珠晖区': '430405',
    '雁峰区': '430406',
    '石鼓区': '430407',
    '蒸湘区': '430408',
    '南岳区': '430412',
    '衡阳县': '430421',
    '衡南县': '430422',
    '衡山县': '430423',
    '衡东县': '430424',
    '祁东县': '430426',
    '耒阳市': '430481',
    '常宁市': '430482'
  }
}